import axios, { AxiosRequestConfig } from 'axios';

import { AxiosServiceResponse, PagedList } from 'interfaces/general';

const instance = axios.create({
  baseURL: `${process.env.FILE_STORAGE_SERVICE_ENDPOINT}/api/v1`,
  headers: {
    // SE ELIMINARIA CUANDO SE TENGA QA ESTABLE API KEY
    // 'Api-key': process.env.REQUEST_HEADER_API_KEY,
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
});

/* REQUESTS & PARAMS */

export enum TicketFileTypeEnum {
  ALL = 0,
  ALL_BUT_IMAGES = 1,
  IMAGES = 2
}

export interface GetFilesByTicketBody {
  ticketId: number;
  text?: string;
  creationDateFromUTC?: string;
  creationDateToUTC?: string;
  orderColumn?: string;
  descending?: boolean;
  pageSize?: number;
  pageNumber?: number;
  fileType?: TicketFileTypeEnum;
}

export interface FileDeleteRequest {
  ticketId: string;
  fileIdList: number[];
}

export interface FileDetail {
  id: string;
  contentType: string;
  createdDateTime: string;
  createdUserDescription: string;
  createdUserId: number;
  description: string;
  evidenceOrder: number;
  fileName: string;
  size: number;
  updatedDateTime: string;
  updatedUserDescription: string;
  updatedUserId: number;
  blobStorageUrlPath: string;
}

/* RESPONSES */

export interface FileUploadResponse {
  id: number;
  fileName: string;
  size: number;
  contentType: string;
  blobStorageUrlPath: string;
}

export interface FileUploaduserRequest {
  fileName?: string;
  description?: string;
  fileContent?: string;
}

export interface FileDeleteResponse {
  message: string | null;
}
export interface File {
  id?: number;
  fileName: string;
  description: string;
  fileContent: string;
}

export interface FileUploadRequest {
  ticketId: string;
  file: File;
  forceDuplicateLoad?: boolean;
}

export interface CheckTicketImageDuplicateRequest {
  ticketId: number;
  file: {
    fileName: string;
    description: string;
    fileContent: string;
  };
}

export interface CheckTicketImageDuplicateData {
  isDuplicate: boolean;
  totalFound: number;
  matches: unknown[];
}

export interface UploadClientLogoRequest {
  clientId: number;
  file: File;
}

export interface UploadFileRequest {
  source: string;
  app: string;
  file: {
    fileName: string;
    description: string;
    fileContent: string;
  };
  reportGuid?: string;
}

interface IFiles {
  files: File[];
}

export interface UploadFileChange extends IFiles {
  changeStepId: number;
}

export interface DeleteFileChange {
  changeStepId: number;
  fileIdList: number[];
}

export interface FilesByChangeRequest extends IFiles {
  changeStepId: number;
}

export interface FileUploadProductModelLogo {
  productModelId: number;
  file: File;
}

export interface FileUploadProductRequest extends IFiles {
  productId: number;
}

export interface AuditReportFileRequest {
  auditId: number;
  auditReportId: number;
  file: File;
}

export interface UploadTowerDocumentRequest {
  towerId: number;
  file: File;
  fileOperation: string;
  fileDetails: string;
  expirationDate: string;
  daysBeforeExpirationNotify: number;
  fileModified?: boolean;
  fileId?: number;
}

export interface UpdateTowerDocumentRequest {
  towerId: number;
  towerDocumentId: number;
  uploadRequest: UploadTowerDocumentRequest;
  userEmail: string;
}

export interface GetFilesByTowerRequest {
  towerId: number;
  text?: string;
  creationDateFromUTC?: string;
  creationDateToUTC?: string;
  orderColumn?: string;
  descending?: boolean;
  pageSize?: number;
  pageNumber?: number;
  fileType?: number;
  userLangId?: number;
}

export interface TowerFile {
  blobStorageUrlPath: string;
  contentType: string;
  createdDateTime: string;
  createdUserDescription: string;
  createdUserId: number;
  description: string;
  fileName: string;
  fileDetails: string;
  fileOperation: string;
  id: number;
  size: number;
  updatedDateTime: string;
  updatedUserDescription: string;
  updateUserId: number;
}

export interface DeleteTowerFilesRequest {
  towerId: number;
  fileIdList: number[];
}

export interface GetFilesByTaskRequest {
  taskId?: number;
  text?: string;
  creationDateFromUTC?: Date;
  creationDateToUTC?: Date;
  orderColumn?: string;
  descending?: boolean;
  pageSize?: number;
  pageNumber?: number;
  fileType?: number;
  changeId?: number;
  problemId?: number;
  releaseId?: number;
  noteId?: number;
}

export interface GetFilesByTaskResponse {
  id?: string | number;
  fileName?: string;
  description?: string;
  size?: number;
  contentType?: string;
  blobStorageUrlPath?: string;
  createdUserDescription?: string;
  updatedDateTime?: string;
  updatedUserId?: string;
  updatedUserDescription?: string;
  fileOperation?: string;
  fileDetails?: string;
  createdUserId?: number;
  createdUser?: string;
  createdDateTime?: Date;
}

export interface AddFilesByTaskRequest {
  taskId?: number;
  file?: File;
  fileOperation?: string;
  fileDetails?: string;
}

export interface AddFilesByTaskResponse {
  id?: number;
  fileName?: string;
  size?: number;
  contentType?: string;
  blobStorageUrlPath?: string;
  fileOperation?: string;
  fileDetails?: string;
}

export interface DeleteFilesByTaskRequest {
  taskId?: number;
  fileIdList?: number[];
}

export interface UploadProblemFile extends IFiles {
  problemId: number;
}

export interface UploadNoteFile extends IFiles {
  noteId: number;
}
export interface DeleteFilesByProblemId {
  problemId?: number;
  fileIdList?: number[];
}

export interface GetSolutionsFilesByID {
  solutionId?: number;
  text?: string;
  creationDateFromUTC?: Date;
  creationDateToUTC?: Date;
  orderColumn?: string;
  descending?: boolean;
  pageSize?: number;
  pageNumber?: number;
  fileType?: number;
}

export interface UploadSolutionsFilesByID {
  solutionId?: number;
  files?: File[];
}

export interface DeleteFilesByNoteId {
  noteId?: number;
  fileIdList?: number[];
}

export interface ResponseSolutionsFilesByID {
  id?: number;
  fileName?: string;
  description?: string;
  size?: number;
  contentType?: string;
  blobStorageUrlPath?: string;
  createdUserDescription?: string;
  updatedDateTime?: null;
  updatedUserId?: null;
  updatedUserDescription?: string;
  fileOperation?: null;
  fileDetails?: null;
  createdUserId?: number;
  createdUser?: null;
  createdDateTime?: Date;
}

export interface DeleteSolutionsFilesByID {
  solutionId?: number;
  fileIdList?: number[];
}

export default {
  instance,
  files: {
    /**
     * Subo un archivo para cambios
     *
     * @tags FileStorage
     * @name uploadChangeFile
     * @request POST:/api/v1/FileStorage/UploadChangeFiles
     * @secure
     */
    uploadChangeFile: (
      data: UploadFileChange,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<FileUploadResponse>>({
        url: `/FileStorage/UploadChangeFiles`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Elimina archivos relacionados a una cambio
     *
     * @tags FileStorage
     * @name DeleteChangeFiles
     * @request POST:/api/v1/FileStorage/DeleteChangeFiles

     * @secure
     */
    DeleteChangeFiles: (
      data: DeleteFileChange,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<FileUploadResponse>>({
        url: `/FileStorage/DeleteChangeFiles`,
        method: 'DELETE',
        data,
        ...config
      }),
    /**
     * Obtiene los archivos e imágenes de un change
     *
     * @tags FileStorage
     * @name GetFilesByChange
     * @request POST:/api/v1/FileStorage/GetFilesByChange
     * @secure
     */
    GetFilesByChange: (
      data: GetFilesByTaskRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<GetFilesByTaskResponse>>
      >({
        url: `/FileStorage/GetFilesByChange`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Obtiene una lista paginada de archivos asociados al ticket enviado
     *
     * @tags fileStorage
     * @name getFilesByTicket
     * @request POST:/api/v1/FileStorage/GetFilesByTicket
     * @secure
     */
    getFilesByTicket: (
      data: GetFilesByTicketBody,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<FileDetail>>>({
        url: `FileStorage/GetFilesByTicket`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * Subo un archivo para el ticket correspondiente
     *
     * @tags fileStorage
     * @name uploadTicketFile
     * @request POST:/api/v1/FileStorage/UploadTicketFile
     * @secure
     */
    uploadTicketFile: (
      data: FileUploadRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<FileUploadResponse>>({
        url: `/FileStorage/UploadTicketFile`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * Verifica si una imagen de ticket es duplicada o similar a otras cargadas
     *
     * @tags fileStorage
     * @name checkTicketImageDuplicate
     * @request POST:/api/v1/FileStorage/CheckTicketImageDuplicate
     * @secure
     */
    checkTicketImageDuplicate: (
      data: CheckTicketImageDuplicateRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<CheckTicketImageDuplicateData>
      >({
        url: `/FileStorage/CheckTicketImageDuplicate`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * Borrar archivos asociados a un ticket
     *
     * @tags fileStorage
     * @name deleteTicketFiles
     * @request POST:/api/v1/FileStorage/DeleteTicketFiles
     * @secure
     */
    deleteTicketFiles: (
      data: FileDeleteRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<FileDeleteResponse>>({
        url: `/FileStorage/DeleteTicketFiles`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Subo un archivo para el Logo del Cliente
     *
     * @tags fileStorage
     * @name AddClientLogo
     * @request POST:/v1/FileStorage/UploadClientLogo
     * @secure
     */
    AddClientLogo: (
      data: UploadClientLogoRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/FileStorage/UploadClientLogo`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Elimino el archivo para el Logo del Cliente
     *
     * @tags fileStorage
     * @name DeleteClientLogo
     * @request DELETE:/v1/FileStorage/UploadClientLogo
     * @secure
     */
    DeleteClientLogo: (idClient: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/FileStorage/DeleteClientLogo/${idClient}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * N/A
     *
     * @tags fileStorage
     * @name uploadFileForExportAndNotification
     * @request POST:/v1/FileStorage/uploadFileForExportAndNotification
     * @secure
     */
    uploadFileForExportAndNotification: (
      data: UploadFileRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<FileUploadResponse>>({
        url: `/FileStorage/UploadFileForExportAndNotification`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * Cargar el logotipo del modelo del producto
     *
     * @tags fileStorage
     * @name uploadProductModelLogo
     * @request POST:/v1/FileStorage/UploadProductModelLogo
     * @secure
     */
    uploadProductModelLogo: (
      data: FileUploadProductModelLogo,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/FileStorage/UploadProductModelLogo`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * Eliminar el logotipo del modelo del producto
     *
     * @tags fileStorage
     * @name deleteProductModelLogo
     * @request POST:/v1/FileStorage/DeleteProductModelLogo/{productModelId}
     * @secure
     */
    deleteProductModelLogo: (
      productModelId: number,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/FileStorage/DeleteProductModelLogo/${productModelId}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * Subo un archivo para el ticket correspondiente
     *
     * @tags fileStorage
     * @name uploadUserFile
     * @request PATCH:/api/v1/FileStorage/UploadUserPicture
     * @secure
     */
    uploadUserFile: (
      data: { file: FileUploaduserRequest },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<FileUploadResponse>>({
        url: `/FileStorage/UploadUserPicture`,
        method: 'PATCH',
        data,
        ...config
      }),

    /**
     * @tags fileStorage
     * @name uploadProductFiles
     * @request POST: /FileStorage/UploadProductFiles
     * @secure
     */
    uploadProductFiles: (
      data: FileUploadProductRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/FileStorage/UploadProductFiles`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * @tags fileStorage
     * @name uploadAuditReportFile
     * @request POST: /FileStorage/UploadAuditReportFile
     * @secure
     */
    uploadAuditReportFile: (
      data: AuditReportFileRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/FileStorage/UploadAuditReportFile`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * @tags fileStorage
     * @name uploadUserContractFile
     * @request POST: /FileStorage/UploadUserContractFile
     * @secure
     */
    uploadUserContractFile: (
      data: {
        file: File;
      },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<FileUploadResponse>>({
        url: `/FileStorage/UploadUserContractFile`,
        method: 'POST',
        data,
        ...config
      }),
    releases: {
      /**
       * Obtiene los archivos e imágenes de un release
       *
       * @tags FileStorage
       * @name GetFilesByRelease
       * @request POST:/api/v1/FileStorage/GetFilesByRelease
       * @secure
       */
      GetFilesByRelease: (
        data: GetFilesByTaskRequest,
        config: AxiosRequestConfig = {}
      ) =>
        instance.request<
          void,
          AxiosServiceResponse<PagedList<GetFilesByTaskResponse>>
        >({
          url: `/FileStorage/GetFilesByRelease`,
          method: 'POST',
          data,
          ...config
        }),
      /**
       * Sube un archivo a un release
       *
       * @tags FileStorage
       * @name UploadReleaseFiles
       * @request POST:/api/v1/FileStorage/UploadReleaseFiles
       * @secure
       */
      UploadReleaseFiles: (
        data: UploadFileChange,
        config: AxiosRequestConfig = {}
      ) =>
        instance.request<void, AxiosServiceResponse<unknown>>({
          url: `/FileStorage/UploadReleaseFiles`,
          method: 'POST',
          data,
          ...config
        }),
      /**
       * Elimina un archivo de un release
       *
       * @tags FileStorage
       * @name DeleteReleaseFiles
       * @request DELETE:/api/v1/FileStorage/DeleteReleaseFiles
       * @secure
       */
      DeleteReleaseFiles: (
        data: UploadFileChange,
        config: AxiosRequestConfig = {}
      ) =>
        instance.request<void, AxiosServiceResponse<unknown>>({
          url: `/FileStorage/DeleteReleaseFiles`,
          method: 'DELETE',
          data,
          ...config
        })
    },
    problems: {
      /**
       * Sube un archivo a un problema
       *
       * @tags FileStorage
       * @name UploadProblemFiles
       * @request POST:/api/v1/FileStorage/UploadProblemFiles
       * @secure
       */
      UploadProblemFiles: (
        data: UploadProblemFile,
        config: AxiosRequestConfig = {}
      ) =>
        instance.request<void, AxiosServiceResponse<FileUploadResponse>>({
          url: `/FileStorage/UploadProblemFiles`,
          method: 'POST',
          data,
          ...config
        }),
      /**
       * Elimina archivos relacionados a un problema
       *
       * @tags FileStorage
       * @name DeleteProblemFiles
       * @request POST:/api/v1/FileStorage/DeleteProblemFiles

       * @secure
       */
      DeleteProblemFiles: (
        data: DeleteFilesByProblemId,
        config: AxiosRequestConfig = {}
      ) =>
        instance.request<void, AxiosServiceResponse<FileUploadResponse>>({
          url: `/FileStorage/DeleteProblemFiles`,
          method: 'DELETE',
          data,
          ...config
        }),
      /**
       * Obtiene los archivos e imágenes de un problema
       *
       * @tags FileStorage
       * @name GetFilesByProblem
       * @request POST:/api/v1/FileStorage/GetFilesByProblem
       * @secure
       */
      GetFilesByProblem: (
        data: GetFilesByTaskRequest,
        config: AxiosRequestConfig = {}
      ) =>
        instance.request<
          void,
          AxiosServiceResponse<PagedList<GetFilesByTaskResponse>>
        >({
          url: `/FileStorage/GetFilesByProblem`,
          method: 'POST',
          data,
          ...config
        }),
      /**
       * Obtiene los archivos e imágenes de una Nota
       *
       * @tags FileStorage
       * @name GetFilesByNote
       * @request POST:/api/v1/FileStorage/GetFilesByNote
       * @secure
       */
      GetFilesByNote: (
        data: GetFilesByTaskRequest,
        config: AxiosRequestConfig = {}
      ) =>
        instance.request<
          void,
          AxiosServiceResponse<PagedList<GetFilesByTaskResponse>>
        >({
          url: `/FileStorage/GetFilesByNote`,
          method: 'POST',
          data,
          ...config
        }),
      /**
       * Carga un archivo a una Nota, en el blob storage
       *
       * @tags FileStorage
       * @name UploadNoteFile
       * @request POST:/api/v1/FileStorage/UploadNoteFile
       * @secure
       */
      UploadNoteFile: (data: UploadNoteFile, config: AxiosRequestConfig = {}) =>
        instance.request<void, AxiosServiceResponse<File[]>>({
          url: `/FileStorage/UploadNoteFile`,
          method: 'POST',
          data,
          ...config
        }),
      /**
       * Elimina archivos relacionados a una Nota
       *
       * @tags FileStorage
       * @name DeleteNoteFiles
       * @request POST:/api/v1/FileStorage/DeleteNoteFiles
       * @secure
       */
      DeleteNoteFiles: (
        data: DeleteFilesByNoteId,
        config: AxiosRequestConfig = {}
      ) =>
        instance.request<void, AxiosServiceResponse<FileUploadResponse>>({
          url: `/FileStorage/DeleteNoteFiles`,
          method: 'DELETE',
          data,
          ...config
        }),
      /**
       * @tags fileStorage
       * @name uploadTowerDocument
       * @request POST: /FileStorage/UploadTowerDocument
       * @secure
       */
      uploadTowerDocument: (
        data: UploadTowerDocumentRequest,
        config: AxiosRequestConfig = {}
      ) =>
        instance.request<
          void,
          AxiosServiceResponse<UploadTowerDocumentRequest>
        >({
          url: `/FileStorage/UploadTowerDocument`,
          method: 'POST',
          data,
          ...config
        }),

      /**
       * @tags fileStorage
       * @name getFilesByTower
       * @request POST: /FileStorage/GetFilesByTower
       * @secure
       */
      getFilesByTower: (
        data: GetFilesByTowerRequest,
        config: AxiosRequestConfig = {}
      ) =>
        instance.request<void, AxiosServiceResponse<PagedList<TowerFile>>>({
          url: `/FileStorage/GetFilesByTower`,
          method: 'POST',
          data,
          ...config
        }),

      /**
       * @tags fileStorage
       * @name deleteTowerFiles
       * @request POST: /FileStorage/DeleteTowerFiles
       * @secure
       */
      deleteTowerFiles: (
        data: DeleteTowerFilesRequest,
        config: AxiosRequestConfig = {}
      ) =>
        instance.request<void, AxiosServiceResponse<FileDeleteResponse>>({
          url: `/FileStorage/DeleteTowerFiles`,
          method: 'POST',
          data,
          ...config
        })
    }
  },
  towers: {
    /**
     * @tags fileStorage
     * @name uploadTowerDocument
     * @request POST: /FileStorage/UploadTowerDocument
     * @secure
     */
    uploadTowerDocument: (
      data: UploadTowerDocumentRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<UploadTowerDocumentRequest>>({
        url: `/FileStorage/UploadTowerDocument`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * @tags fileStorage
     * @name updateTowerDocument
     * @request POST: /FileStorage/UpdateTowerDocument
     * @secure
     */
    updateTowerDocument: (
      data: UpdateTowerDocumentRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<UploadTowerDocumentRequest>>({
        url: `/FileStorage/UpdateTowerDocument`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * @tags fileStorage
     * @name getFilesByTower
     * @request POST: /FileStorage/GetFilesByTower
     * @secure
     */
    getFilesByTower: (
      data: GetFilesByTowerRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<TowerFile>>>({
        url: `/FileStorage/GetFilesByTower`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * @tags fileStorage
     * @name deleteTowerFiles
     * @request POST: /FileStorage/DeleteTowerFiles
     * @secure
     */
    deleteTowerFiles: (
      data: DeleteTowerFilesRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<FileDeleteResponse>>({
        url: `/FileStorage/DeleteTowerFiles`,
        method: 'POST',
        data,
        ...config
      })
  },
  tasksFiles: {
    /**
     * @tags fileStorage
     * @name getTaskFiles
     * @request POST: /FileStorage/GetFilesByTask
     * @secure
     */
    getTaskFiles: (
      data: GetFilesByTaskRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<GetFilesByTaskResponse>>
      >({
        url: `/FileStorage/GetFilesByTask`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags fileStorage
     * @name addTaskFiles
     * @request POST: /FileStorage/UploadTaskFile
     * @secure
     */
    addTaskFiles: (
      data: AddFilesByTaskRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<AddFilesByTaskResponse>>({
        url: `/FileStorage/UploadTaskFile`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags fileStorage
     * @name deleteTaskFiles
     * @request POST: /FileStorage/DeleteTaskFiles
     * @secure
     */
    deleteTaskFiles: (
      data: DeleteFilesByTaskRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/FileStorage/DeleteTaskFiles`,
        method: 'POST',
        data,
        ...config
      })
  },
  solutions: {
    /**
     * Obtiene los archivos e imágenes de una solucion
     *
     * @tags FileStorage
     * @name GetFilesBySolutionId
     * @request POST:/api/v1/FileStorage/GetFilesBySolution
     * @secure
     */
    GetFilesBySolutionId: (
      data: GetSolutionsFilesByID,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<ResponseSolutionsFilesByID>>
      >({
        url: `/FileStorage/GetFilesBySolution`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Sube los archivos e imágenes de una solucion
     *
     * @tags FileStorage
     * @name UploadFilesBySolutionId
     * @request POST:/api/v1/FileStorage/UploadSolutionFile
     * @secure
     */
    UploadFilesBySolutionId: (
      data: UploadSolutionsFilesByID,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<FileUploadResponse>>({
        url: `/FileStorage/UploadSolutionFile`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Elimina los archivos e imágenes de una solucion
     *
     * @tags FileStorage
     * @name DelteFilesBySolutionId
     * @request POST:/api/v1/FileStorage/DeleteSolutionFiles
     * @secure
     */
    DelteFilesBySolutionId: (
      data: DeleteSolutionsFilesByID,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/FileStorage/DeleteSolutionFiles`,
        method: 'POST',
        data,
        ...config
      })
  },
  solutions: {
    /**
     * Obtiene los archivos e imágenes de una solucion
     *
     * @tags FileStorage
     * @name GetFilesBySolutionId
     * @request POST:/api/v1/FileStorage/GetFilesBySolution
     * @secure
     */
    GetFilesBySolutionId: (
      data: GetSolutionsFilesByID,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<ResponseSolutionsFilesByID>>
      >({
        url: `/FileStorage/GetFilesBySolution`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Sube los archivos e imágenes de una solucion
     *
     * @tags FileStorage
     * @name UploadFilesBySolutionId
     * @request POST:/api/v1/FileStorage/UploadSolutionFile
     * @secure
     */
    UploadFilesBySolutionId: (
      data: UploadSolutionsFilesByID,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<FileUploadResponse>>({
        url: `/FileStorage/UploadSolutionFile`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Elimina los archivos e imágenes de una solucion
     *
     * @tags FileStorage
     * @name DelteFilesBySolutionId
     * @request POST:/api/v1/FileStorage/DeleteSolutionFiles
     * @secure
     */
    DelteFilesBySolutionId: (
      data: DeleteSolutionsFilesByID,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/FileStorage/DeleteSolutionFiles`,
        method: 'POST',
        data,
        ...config
      })
  },
  solutions: {
    /**
     * Obtiene los archivos e imágenes de una solucion
     *
     * @tags FileStorage
     * @name GetFilesBySolutionId
     * @request POST:/api/v1/FileStorage/GetFilesBySolution
     * @secure
     */
    GetFilesBySolutionId: (
      data: GetSolutionsFilesByID,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<ResponseSolutionsFilesByID>>
      >({
        url: `/FileStorage/GetFilesBySolution`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Sube los archivos e imágenes de una solucion
     *
     * @tags FileStorage
     * @name UploadFilesBySolutionId
     * @request POST:/api/v1/FileStorage/UploadSolutionFile
     * @secure
     */
    UploadFilesBySolutionId: (
      data: UploadSolutionsFilesByID,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<FileUploadResponse>>({
        url: `/FileStorage/UploadSolutionFile`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Elimina los archivos e imágenes de una solucion
     *
     * @tags FileStorage
     * @name DelteFilesBySolutionId
     * @request POST:/api/v1/FileStorage/DeleteSolutionFiles
     * @secure
     */
    DelteFilesBySolutionId: (
      data: DeleteSolutionsFilesByID,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/FileStorage/DeleteSolutionFiles`,
        method: 'POST',
        data,
        ...config
      })
  }
};
